import * as yup from 'yup';
import { linkRegex } from 'utils';

export default ({ showRegistrationEmail, emailMandatory }) => {
  if (showRegistrationEmail) {
    if (emailMandatory) {
      return {
        firstName: yup
            .string()
            .trim()
            .required('jquery.validation.field.required, ssp.register.firstname')
            .test('firstName', 'ssp.field.firstname.invalid', (value) => !linkRegex.test(value)),
        lastName: yup
            .string()
            .trim()
            .required('jquery.validation.field.required, ssp.register.lastname')
            .test('lastName', 'ssp.field.lastname.invalid', (value) => !linkRegex.test(value)),
        email: yup
            .string()
            .nullable()
            .trim()
            .email('jquery.validation.email')
            .required('jquery.validation.field.required, new.registration.signup.create.account.label.emailAddress'),
      };
    }
    return {
      firstName: yup
          .string()
          .trim()
          .required('jquery.validation.field.required, ssp.register.firstname')
          .test('firstName', 'ssp.field.firstname.invalid', (value) => !linkRegex.test(value)),
      lastName: yup
          .string()
          .trim()
          .required('jquery.validation.field.required, ssp.register.lastname')
          .test('lastName', 'ssp.field.lastname.invalid', (value) => !linkRegex.test(value)),
      email: yup
          .string()
          .nullable()
          .trim()
          .email('jquery.validation.email')
    };
  }
  return {
    firstName: yup
        .string()
        .trim()
        .required('jquery.validation.field.required, ssp.register.firstname')
        .test('firstName', 'ssp.field.firstname.invalid', (value) => !linkRegex.test(value)),
    lastName: yup
        .string()
        .trim()
        .required('jquery.validation.field.required, ssp.register.lastname')
        .test('lastName', 'ssp.field.lastname.invalid', (value) => !linkRegex.test(value))
  };
};
